module.exports = __webpack_public_path__ + "static/img/redeemcard.d4e797f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gift/redeemcard.png
// module id = sJph
// module chunks = 35